import * as Yup from 'yup';

import { FORM_ERROR_MESSAGES, MAX_SUBJECT_LENGTH, MIN_LENGTH } from '@hero/constants';

export const remindFormData = [
  {
    name: 'subject',
    label: 'Subject line',
    placeholder: 'Email subject line here*',
    type: 'text',
    maxLength: MAX_SUBJECT_LENGTH,
    value: 'Don’t forget to redeem your gift!'
  }
];

export const remindFormValidationSchema = Yup.object({
  subject: Yup.string()
    .min(MIN_LENGTH, FORM_ERROR_MESSAGES.min2Char)
    .max(MAX_SUBJECT_LENGTH, FORM_ERROR_MESSAGES.max100Char)
    .required()
});
